import script from "./TechnologyAssetsFilterSortBy.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechnologyAssetsFilterSortBy.vue?vue&type=script&setup=true&lang=ts"

import "./TechnologyAssetsFilterSortBy.vue?vue&type=style&index=0&id=6aff4111&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aff4111"]])

export default __exports__